import React, { useContext } from "react";
import { AppContext } from "../States/AppContext";
import { Link} from "react-router-dom";

//styles
import { SkClose, SkTopLine, SkWrapper } from "./SmartKeyBox.elements";
import {
  MainSetupItem,
  MainSetupSettings,
  SettingsBack,
} from "./SettingsChangesWaves.elements";

//icons
import { AiOutlineClose } from "react-icons/ai";
import { MdOutlineArrowBackIosNew } from "react-icons/md";


const ChangeWave = () => {
  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }
  const { state, setState } = useContext(AppContext);

  const handleClick = (index) => {
    
    setState((prevState) => {
      const updatedWave = prevState.waveData.map((wave, i) => {
        if (i === index) {
          return { ...wave, primary: true };
        } else {
          return { ...wave, primary: false };
        }
      });
      return {
        ...prevState,
        waveData: updatedWave,
        ecgOffWave1: false,
        waveChanges: prevState.waveChanges + 1,
        // waveChangesTest:true
      };
    });
  };

  return (
    <SkWrapper>
      <SkTopLine>
        Change Wave
        {/* <Link to="/"> */}
        <SettingsBack onClick={handleBackButtonClick}>
          <MdOutlineArrowBackIosNew></MdOutlineArrowBackIosNew>
        </SettingsBack>
        {/* </Link> */}
        <Link to="/">
          <SkClose>
            <AiOutlineClose></AiOutlineClose>
          </SkClose>
        </Link>
      </SkTopLine>
      <MainSetupSettings>
        <Link to="/settings/adjustsize">
          <MainSetupItem>Adjust Size: x1</MainSetupItem>
        </Link>
        <MainSetupItem>Multi-lead View</MainSetupItem>
        <MainSetupItem>Primary Lead</MainSetupItem>
        <MainSetupItem>Secondary Lead</MainSetupItem>

        {state.waveData.map((wave, index) => (
          <MainSetupItem key={wave.id} onClick={() => handleClick(index)}>
            {wave.buttonName}
          </MainSetupItem>
        ))}
      </MainSetupSettings>
    </SkWrapper>
  );
};

// skip for now

const ChangeWave2 = () => {
  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  const { state, setState } = useContext(AppContext);

  const handleClick = (index) => {
    setState((prevState) => {
      const updatedWave = prevState.waveData.map((wave, i) => {
        if (i === index) {
          return { ...wave, secondary: true };
        } else {
          return { ...wave, secondary: false };
        }
      });
      return {
        ...prevState,
        waveData: updatedWave,
        ecgOffWave2: false,
        waveChanges: prevState.waveChanges + 1,
      };
    });
  };

  return (
    <SkWrapper>
      <SkTopLine>
        Change Wave
        {/* <Link to="/"> */}
        <SettingsBack onClick={handleBackButtonClick}>
          <MdOutlineArrowBackIosNew></MdOutlineArrowBackIosNew>
        </SettingsBack>
        {/* </Link> */}
        <Link to="/">
          <SkClose>
            <AiOutlineClose></AiOutlineClose>
          </SkClose>
        </Link>
      </SkTopLine>
      <MainSetupSettings>
        <Link to="/settings/adjustsize">
          <MainSetupItem>Adjust Size: x1</MainSetupItem>
        </Link>
        <MainSetupItem>Multi-lead View</MainSetupItem>
        <MainSetupItem>Primary Lead</MainSetupItem>
        <MainSetupItem>Secondary Lead</MainSetupItem>
        {state.waveData.map((wave, index) => (
          <MainSetupItem key={wave.id} onClick={() => handleClick(index)}>
            {wave.buttonName}
          </MainSetupItem>
        ))}
      </MainSetupSettings>
    </SkWrapper>
  );
};

export { ChangeWave, ChangeWave2 };
